import { Injectable } from '@angular/core';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/core/service/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CabsListService {
  constructor(private apiService: ApiService) { }

  // getMyCABsList(model) {
  //   return this.apiService
  //     .post(`${environment.apiUrl}/api/system/list_all_my_cab_profiles`, model)
  //     .pipe(catchError(this.handleError));
  // }
  getAllCABsList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_my_cab_profiles`, model)
      .pipe(catchError(this.handleError));
  }

  getAllAccreditationBoidesList(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/accreditation_bodies_system`, model)
      .pipe(catchError(this.handleError));
  }


  AddNewEntity(model, img) {
    const formData = new FormData();
    formData.append('cab_name_en', model.cab_name_en);
    formData.append('cab_address', model.cab_address);
    formData.append('cab_reigon', model.cab_reigon);
    formData.append('cab_city', model.cab_city);
    formData.append('country_token', model.country_token);
    formData.append('cab_po_box', model.cab_po_box);
    formData.append('cab_phone', model.cab_phone);
    formData.append('phone_token', model.phone_token);
    formData.append('fax_token', model.fax_token);
    formData.append('cab_fax', model.cab_fax);
    formData.append('cab_email', model.cab_email);
    formData.append('cab_website', model.cab_website);


    if (img?.name) {
      formData.append('cab_logo', img, img?.name);
    }

    return this.apiService
      .post(`${environment.apiUrl}/api/system/addNewCabProfile`, formData)
      .pipe(catchError(this.handleError));
  }

  directPublish(modal, cab_logo_file) {
    const formData = new FormData();
    if (cab_logo_file) {
      formData.append('cab_logo', cab_logo_file, cab_logo_file?.name);
    }
    // enAaccCertificate.forEach(file => {
    //   formData.append('certificate_file', file, file.name);
    // });
    // arAaccCertificate.forEach(file => {
    //   formData.append('certificate_ar_file', file, file.name);
    // });
    // accScopes.forEach(file => {
    //   formData.append('scopes_file', file, file.name);
    // });

    for (const prop in modal) {
      if (modal[prop] instanceof Array || modal[prop] instanceof Object) {
        formData.append(prop, JSON.stringify(modal[prop]));
      } else {
        formData.append(prop, modal[prop]);
      }
    }

    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_new_cab_admin`, formData)
      .pipe(catchError(this.handleError));
  }

  addNewCertificate(modal) {
    const formData = new FormData();

    for (const prop in modal) {
      if (modal[prop] instanceof Array || modal[prop] instanceof Object) {
        console.log(prop);
        formData.append(prop, JSON.stringify(modal[prop]));
      } else {
        console.log(prop);
        formData.append(prop, modal[prop]);
      }
    }
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_new_cab_certificate`, formData)
      .pipe(catchError(this.handleError));
  }

  exportAccreditationBoidesAsExcel(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/accreditation_bodies_system_export`,
        model
      )
      .pipe(catchError(this.handleError));
  }
  exportAccreditationBoidesAsPdf(model) {
    return this.apiService
      .getDownload(
        `${environment.apiUrl}/api/system/accreditation_bodies_system_export_pdf`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  getAllSchemas() {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/get_all_schemas`)
      .pipe(catchError(this.handleError));
  }

  getSchemeSectorPaginated(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/get_schema_scopes_settings`, model)
      .pipe(catchError(this.handleError));
  }

  getSchemeSector(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/get_scope_assessor`, model)
      .pipe(catchError(this.handleError));
  }

  handleError(error) {
    return throwError(error);
  }
}
